import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.js";

export const useStepAgentSignupStore = (pinia, hot) =>
  defineStore("step-agent-signup", {
    getters: {
      hideNoLicenseBanner: () => true,
      step: () => STEP.AGENT_SIGN_UP,
      next: () => null,
      previous: () => null,
      skipStepSave: () => true,
      hidesHeader: () => true,
    },
  })(pinia, hot);
